export const SelectDirection = Object.freeze({
  PREVIOUS: 'PREVIOUS',
  NEXT: 'NEXT',
});

export const selectAdjacentItem = (
  direction,
  selected,
  pending,
  history
) => {
  const pendingIndex = pending.findIndex(
    (ref) => ref.id === selected.id
  );
  const historyIndex =
    history?.findIndex((ref) => ref.id === selected.id) ?? -1;
  if (pendingIndex === -1 && historyIndex === -1) return false;

  let collectionIndex;
  let collection;
  let newDirection;

  if (direction === SelectDirection.PREVIOUS) {
    if (pendingIndex < 1) {
      collectionIndex = historyIndex;
      collection = history;
      newDirection = 1;
    } else {
      collectionIndex = pendingIndex;
      collection = pending;
      newDirection = -1;
    }
  } else if (direction === SelectDirection.NEXT) {
    if (historyIndex > 0) {
      collectionIndex = historyIndex;
      collection = history;
      newDirection = -1;
    } else {
      collectionIndex = pendingIndex;
      collection = pending;
      newDirection = 1;
    }
  } else {
    return false;
  }

  const adjacentIndex = collectionIndex + newDirection;
  if (adjacentIndex >= 0 && adjacentIndex < collection.length) {
    return collection[adjacentIndex];
  }

  return false;
};
